<div class="content-wrapper">
    <div class="content-body">
        <section id="package">
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <h2 class="mt-5px">My Products</h2>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <button class="btn btn-primary pull-right color-white color-white users-btn"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                </div>
            </div>
            <div class="row search-card mt-3" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="name" placeholder="Name">
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="number" formControlName="quantity"
                                           placeholder="Quantity">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="number" formControlName="mrp"
                                           placeholder="Amount">
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="batch"
                                           placeholder="Batch">
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mt-3" *ngIf="myProducts && myProducts.length > 0; else noDataToShow">
                <div class="col-12">
                    <div class="card" *ngFor="let myProduct of myProducts; let i = index">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="f_20 font-weight-bold">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}.</span>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                    <span class="ml-5px">
                                        <img [src]="imageBaseUrl+myProduct?.image?.partial_url" width="50px" height="50px"
                                             [alt]="myProduct?.name"/>
                                    </span>
                                </div>
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 mt-auto mb-auto text-center">
                                    <span class="font-weight-bold text-italic f_18">{{myProduct?.name}}</span>
                                    <br>
                                    <small class="text-italic">Product Name</small>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 mt-auto mb-auto text-center">
                                    <span class="font-weight-bold text-italic f_18">{{myProduct?.quantity | IndianNumber}}</span>
                                    <br>
                                    <small class="text-italic">Quantiy</small>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 mt-auto mb-auto text-center">
                                    <span class="font-weight-bold text-italic f_18 mr-10px">&#8377;{{myProduct?.distributed_price | IndianNumber}}</span>
                                    <span class="text-strike f_12">(&#8377;{{myProduct?.mrp | IndianNumber}})</span>
                                    <br>
                                    <small class="text-italic">Amount</small>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 mt-auto mb-auto text-center">
                                    <span class="font-weight-bold text-italic f_18">{{myProduct?.hsn}}</span>
                                    <br>
                                    <small class="text-italic">HSN</small>
                                </div>
                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 mt-auto mb-auto text-center">
                                    <span class="font-weight-bold text-italic f_18">{{myProduct?.tax}}%</span>
                                    <br>
                                    <small class="text-italic">Tax</small>
                                </div>
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 mt-auto mb-auto text-center">
                                    <span class="font-weight-bold text-italic f_18">{{myProduct?.batch}}</span>
                                    <br>
                                    <small class="text-italic">Batch</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noDataToShow>
                <div class="row mt-3">
                    <div class="col-12">
                        <div class="card p-50px">
                            <div class="card-body text-center">
                                <div class="row">
                                    <div class="col-12">
                                        <i class="fa fa-shopping-cart fa-3x" aria-hidden="true"></i>
                                    </div>
                                    <div class="col-12 text-center">
                                        No products to show
                                    </div>
                                    <div class="col-12 text-center mt-10px">
                                        <button class="btn btn-primary" (click)="goTo('products')">
                                            <i class="fa fa-cart-plus mr-10px" aria-hidden="true"></i>Buy Now
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="row pagination-table">
                <ngb-pagination class="pagination-primary" [collectionSize]="pagination.total"
                                [(page)]="pagination.page" [boundaryLinks]="true"
                                [pageSize]="pagination.perpage" [maxSize]="5"
                                (pageChange)="onPageChange($event)">
                    <ng-template ngbPaginationPrevious>
                        <span [data-feather]="'chevron-left'" [size]="18"
                              [class]="'font-weight-bolder'">
                        </span>
                    </ng-template>
                    <ng-template ngbPaginationNext>
                        <span [data-feather]="'chevron-right'" [size]="18"
                              [class]="'font-weight-bolder'">
                        </span>
                    </ng-template>
                </ngb-pagination>
            </div>
        </section>
    </div>
</div>
